import i18n from 'i18next'
export function changeLanguagePref(
  i18nInstance: typeof i18n,
  language: string
) {
  i18nInstance.changeLanguage(language)
  window.localStorage.setItem('language', language)
}

export function getLanguagePref() {
  return window.localStorage.getItem('language')
}

export function getLanguageString(language: string) {
  switch (language) {
    case 'en':
      return '简体中文'
    case 'cn':
      return 'English'
    default:
      return language
  }
}
